/* 将小数转为百分比 */
export default function (number) {
    const percentage = (number ).toFixed(2);
    return percentage + '%';
}